import { render, staticRenderFns } from "./HistoryClass.vue?vue&type=template&id=58598ace&scoped=true&"
import script from "./HistoryClass.vue?vue&type=script&lang=js&"
export * from "./HistoryClass.vue?vue&type=script&lang=js&"
import style0 from "./HistoryClass.vue?vue&type=style&index=0&id=58598ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58598ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
